import useSWR from 'swr';

import { buildUrl, InsightsApi } from 'src/api/Api';
import { PatientProfile } from 'src/domain/patient/Patients';

export const PATIENT = (patientId: string) => `/patients/${patientId}`;

export function usePatientProfile(patientId?: string) {
  const url = patientId && buildUrl(PATIENT(patientId));
  const { data, error, isValidating } = useSWR(
    url,
    (_url) => InsightsApi.get<PatientProfile>(_url),
    {
      revalidateOnFocus: false,
      suspense: true,
    }
  );

  return {
    isLoading: isValidating,
    patient: data,
    error,
  };
}

export function fetchPatientData(patientId: string) {
  return InsightsApi.get<PatientProfile>(buildUrl(PATIENT(patientId)));
}

export function deletePatient(patientId: string) {
  return InsightsApi.delete(buildUrl(PATIENT(patientId)));
}
